import {Component, OnInit} from '@angular/core';
import {Apollo, gql} from "apollo-angular";
import {Store} from "@ngxs/store";
import {Portfolio} from "../../portfolio/state/portfolio.actions";
import {NzAutocompleteOptionComponent} from "ng-zorro-antd/auto-complete";
import {Router} from "@angular/router";

@Component({
    selector: 'dh-app-header-search',
    templateUrl: './app-header-search.component.html',
    styles: [`:host {
        flex: 1
    }`
    ]
})
export class AppHeaderSearchComponent implements OnInit {

    optionGroups: any = [];
    searchInput?: string | null;

    constructor(private apollo: Apollo, private store: Store, private router: Router) {
    }

    ngOnInit(): void {
        this.optionGroups = [];
    }

    search(): void {
        this.onChange(this.searchInput ?? null);
    }

    onChange(value: string | null): void {
        this.optionGroups = [];
        if (value == null || value == "") {
            return;
        }
        this.apollo.query<any>({
            query: gql`query search($input: String!){
                globalSearch(input: $input){
                    name
                    type
                    items {
                        id
                        name
                        description
                    }
                }
            }`,
            variables: {
                input: value
            }
        }).subscribe(result => {
                this.optionGroups = result.data.globalSearch;
            }
        )

    }

    open(option: any, group: any) {
        setTimeout(() => {
            this.optionGroups = [];
            this.searchInput = "";
        }, 200);
        if (group.type == 'location') {
            this.router.navigate(["/", "portfolio", "location", option.id]);
            return;
        }
        if (group.type == 'building') {
            this.router.navigate(["/", "portfolio", "building", option.id]);
            return;
        }
        if (group.type == "object") {
            this.router.navigate(["/", "portfolio", "object", option.id]);
        }
    }

    onSelect($event: NzAutocompleteOptionComponent) {
        let option = $event.nzValue.option;
        let group = $event.nzValue.group;

        this.open(option, group);
    }

}
